import { render, staticRenderFns } from "./WagonExecutionViewPanel.vue?vue&type=template&id=2fed877e&scoped=true"
import script from "./WagonExecutionViewPanel.vue?vue&type=script&lang=js"
export * from "./WagonExecutionViewPanel.vue?vue&type=script&lang=js"
import style0 from "./WagonExecutionViewPanel.vue?vue&type=style&index=0&id=2fed877e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fed877e",
  null
  
)

export default component.exports